module.exports = __webpack_public_path__ + "img/haichang-black.05d6760d.png";